(function() {
  'use strict';

  angular
    .module('admin.users.details.email_changes.service', [])
    .factory('EmailChangesService', EmailChangesService);

  /** @ngInject */
  function EmailChangesService($http, $q, API) {
    function list(userId) {
      var defer = $q.defer();

      $http
        .get(API.API_URL + "admin/users/" + userId + "/email_changes")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    return{
      list: list
    };

  }

})();
